import FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
export default {
  // 导出Excel表格
  exportExcel(name, tableName) {
    //name表示生成excel的文件名     tableName表示表格的id
    var sel = XLSX.utils.table_to_book(document.querySelector(tableName))
    var selIn = XLSX.write(sel, { bookType: 'xlsx', bookSST: true, type: 'array' })
    try {
      FileSaver.saveAs(new Blob([selIn], { type: 'application/octet-stream' }), name)
    } catch (e) {
      if (typeof console !== 'undefined') console.log(e, selIn)
    }
    return selIn
  },
  // 多工作表导出：sheetNames为每个工作表的名字，tableIds为每个表格的选择器（一一对应）
  exportExcelSheets(sheetNames, tableIds, name) {
    var wb = XLSX.utils.book_new()
    sheetNames.forEach((sheetName, i) => {
      var table = document.querySelector(tableIds[i])
      if (!table) return
      var ws = XLSX.utils.table_to_sheet(table)
      XLSX.utils.book_append_sheet(wb, ws, sheetName)
    })
    var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
    try {
      FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), name)
    } catch (e) {
      if (typeof console !== 'undefined') console.log(e, wbout)
    }
    return wbout
  }
};



// WEBPACK FOOTER //
// ./src/plugins/htmlToExcel.js